module.exports = __webpack_public_path__ + "img/gb.5aef6544.svg";